import { DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchFreshMandatoryBarcodes } from 'utils/api/freshMandatoryBarcodeApi'
import { getColumns } from './utils'

const FreshMandatoryBarcodeTable = () => {
  const [data, setData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()

  const getRows = async () => {
    setLoading(true)
    const { limit, search: searchTerm, page } = getAllQueries()

    try {
      const { data: response } = await fetchFreshMandatoryBarcodes({
        limit: limit || 10,
        page: page || 1,
        search: searchTerm,
      })
      setData({ ...response })
    } catch {
      setData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRows()
  }, [search])

  const columns = useMemo(() => getColumns(), [])

  return (
    <>
      <DataTable
        columns={columns}
        rows={loading ? null : data?.docs}
        identifier="_id"
      />

      <DataTablePagination
        currentPage={data?.page}
        totalPages={data?.totalPages}
        hasNextPage={data?.hasNextPage}
        hasPrevPage={data?.hasPrevPage}
        limit={data?.limit}
        nextPage={data?.nextPage}
        prevPage={data?.prevPage}
      />
    </>
  )
}

export default FreshMandatoryBarcodeTable
